import wixCRM from 'wix-crm';
import wixUsers from 'wix-users';

$w.onReady(function () {
	let user = wixUsers.currentUser;
	let userId = user.id;
	

	wixCRM.emailContact('RynGqEl', userId, {
	variables: {
	price: 1,
	studentName: "demo",
	studentEmail: "demo@expalme.com"
	}});
});
